const { default: CommonServices } = require("./common/common");

class FAQManagementService extends CommonServices {
  constructor() {
    super("/faq");
  }
}

const faqManagementService = new FAQManagementService();
export default faqManagementService;
